import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import './CustomDropdown.css';

export interface CustomMultiSelectOption {
    label: string;
    value: any;
}

export interface CustomMultiSelectProps {
    label: string;
    options: CustomMultiSelectOption[];
    value: any[];
    onChange: (value: any[]) => void;
    disabled?: boolean;
    placeholder?: string;
    maxSelectedLabels?: number;
    selectedItemsLabel?: string;
    showFilterBadge?: boolean;
}

/**
 * CustomMultiSelect wraps PrimeReact's MultiSelect
 * to provide consistent styling with CustomDropdown
 */
const CustomMultiSelect: React.FC<CustomMultiSelectProps> = ({
                                                                 label,
                                                                 options,
                                                                 value,
                                                                 onChange,
                                                                 disabled = false,
                                                                 placeholder = 'Select items',
                                                                 maxSelectedLabels = 1,
                                                                 selectedItemsLabel = '{0} items selected',
                                                                 showFilterBadge = false,
                                                             }) => {
    // When showFilterBadge is enabled, show "x/y suffix" format inside the dropdown
    // Extract suffix from selectedItemsLabel (e.g., "{0} byggnadstyper" -> "byggnadstyper")
    const computedSelectedItemsLabel = showFilterBadge
        ? `{0}/${options.length} ${selectedItemsLabel.replace('{0} ', '')}`
        : selectedItemsLabel;

    return (
        <div className="custom-dropdown-root">
            <label className="custom-dropdown-label">{label}</label>
            <MultiSelect
                value={value}
                onChange={(e) => onChange(e.value)}
                options={options}
                optionLabel="label"
                placeholder={placeholder}
                maxSelectedLabels={maxSelectedLabels}
                selectedItemsLabel={computedSelectedItemsLabel}
                showSelectAll={true}
                selectAllLabel="Visa alla"
                showClear={false}
                disabled={disabled}
                display="comma"
                className="custom-multiselect"
                panelClassName="custom-multiselect-panel"
                style={{ minWidth: '200px' }}
            />
        </div>
    );
};

export default CustomMultiSelect;